import { http } from '@utils/interceptor'
import jsCookie from 'js-cookie'
/**
 * 临时
 * 服务待产包
 * CMS配置
 */
export async function getSpuIdsFromCMS() {
  const url = '//cms.cekid.com/publish/999/package_of_child_birth_service.json'
  try {
    const res = await http.get(url)
    if (+res.code === 0) {
      return res.data
    }
    return {}
  } catch (error) {
    throw error
  }
}